import React, { useState } from 'react';
import styled from 'styled-components';

import TokenForm, { DrawerForm } from 'components/token/TokenForm';

import { useRecoilState, useRecoilValue } from 'recoil';
import { tokenState, metamaskState, feesState, contractState, web3State } from 'global/state';
import { Tag, Button, message } from 'antd';
import { abi, bytecode } from 'global/contracts/standard';
import web3 from 'global/web3';
import { Network, ETH_URL, BSC_URL, PAYMENT_ADDRESS, ETH_FEES_AMOUNT_WEI, BNB_FEES_AMOUNT_WEI } from 'components/utils';


const Deploy = (props) => {
  const token = useRecoilValue(tokenState);
  // const fees = useRecoilValue(feesState);
  const metamask = useRecoilValue(metamaskState);
  const [ contract, setContract ] = useRecoilState(contractState);
  const [ fees, setFees ] = useRecoilState(feesState);

  const [ loading, setLoading ] = useState(false);
  const [ feesLoading, setFeesLoading ] = useState(false);

  const contractBaseUrl = metamask.network === Network.ETHEREUM ? ETH_URL : BSC_URL;


  const handleFeesPayment = () => {
    const FEES_AMOUNT = metamask.network === Network.ETHEREUM ? ETH_FEES_AMOUNT_WEI : BNB_FEES_AMOUNT_WEI;
    const CHAIN_ID = metamask.network === Network.ETHEREUM ? 1 : 56;
    console.log('CHAIN_ID', CHAIN_ID)

    try {
      setFeesLoading(true);
      web3.eth.sendTransaction({
        from: metamask.address,
        to: PAYMENT_ADDRESS,
        value: FEES_AMOUNT.toString(),
        chainId: CHAIN_ID,
      }, ( error, transactionId ) => {
        if (error) {
          console.error('error', error);
          message.error(`Error occured while paying the fees. Error: ${error.message}`)
          setFeesLoading(false);
          return;
        }
        console.log('Transaction ID :', transactionId);
        message.info(`Payment transaction in progress - ${transactionId}`);
        setFees({
          ...fees,
          status: true,
          transactionHash: transactionId
        });
        setFeesLoading(false);
      });
    } catch (error) {
      console.log('error', error);
      message.error(error?.message || 'Error occurred!');
    }

  }



  const addContractToMetaMask = async () => {
    try {
      const wasAdded = await window?.ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20', // Initially only supports ERC20, but eventually more!
          options: {
            address: contract.address, // The address that the token is at.
            symbol: token.symbol, // A ticker symbol or shorthand, up to 5 chars.
            decimals: token.decimal, // The number of decimals in the token
            image: '', // A string url of the token logo
          },
        },
      });
    } catch (err) {
      console.log('error occured while adding token to metamask!');
      message.error(`Error occured while adding token to metamask!`);
    }

  }



  const handleContractDeployment = async () => {
    setLoading(true);

    // verify the payment transaction - fees.transactionHash
    message.info('Verifying fees payment transaction. Please wait.');
    const receipt = await web3.eth.getTransactionReceipt( fees.transactionHash );
    console.log('receipt', receipt)
    if ( ! receipt || ! receipt?.status ) {
      message.info('Transaction is not completed yet. Please wait for the payment transaction to complete.');
      setLoading(false);
      return;
    }


    try {
      let generatedTransHash = '';
      const standardtokenContract = new web3.eth.Contract(abi);
      console.log('standardtokenContract', standardtokenContract);
      // token.supply.toString().padEnd(parseInt(token.supply.length) + parseInt(token.decimal),'0')
      const totalTokenSupply = `${token.supply.toString()}${Array(token.decimal).fill('0').join('')}`;

      standardtokenContract.deploy({
        data: '0x' + bytecode,
        arguments: [ totalTokenSupply, token.name, token.decimal, token.symbol ]
      })
      .send({
        from: metamask.address
      },
      function (error, transactionHash) {
        if (error) {
          console.error('error', error);
          setLoading(false);
          return;
        }
        console.log('Transaction Hash :', transactionHash);
        message.info(`Contract creation is in progress - ${transactionHash}`);
        generatedTransHash = transactionHash;
      })
      .on('confirmation', function () {
        return;
      })
      .then(function (newContractInstance) {
        if ( ! newContractInstance.options.address ) {
          console.log('error - newContractInstance', newContractInstance);
          return;
        }
        console.log('newContractInstance', newContractInstance);
        const newContractAddress = newContractInstance.options.address;
        console.log('contract address', newContractAddress);
        message.success(`Contract creation successful!. Contract address: ${newContractAddress}`);
        console.log('generatedTransHash', generatedTransHash)
        setContract({
          deployed: true,
          status: true,
          address: newContractAddress,
          transactionHash: generatedTransHash,
        });
        setLoading(false);
      }).catch(function (error) {
        console.error('catch error', error);
        setLoading(false);
      })

    } catch (error) {
      console.log('try catch error', error);
      message.error(error?.message || 'Error occurred!');
    }

  }


  return (
    <DetailsContainer>
      <p style={{ marginBottom: 5 }}>Let's Deploy The Token Contract Now!</p>
      <p>Total Fees: <Tag color="#108ee9" style={{ fontSize: 14 }}>{fees.amount} {fees.currency}</Tag></p>

      <FeesContainer>
        <Button type="primary" ghost block onClick={ handleFeesPayment } loading={feesLoading}>Pay The Fees</Button>
        <p>After you pay the fees, We will verify it and You can click on the button below to deploy the contract.</p>
        <p style={{color: '#ff0000'}}>Please pay the exact amount otherwise you won't be able to deploy your token contract.</p>
      </FeesContainer>

      { contract && ! contract.deployed &&
      <div style={{ marginTop: 20 }}>
        <Button type="primary" block onClick={ handleContractDeployment } loading={loading} style={{ marginBottom: 15 }} disabled={ fees.status ? false : true }>Deploy The Contract</Button>
        { loading && <p>Please be patient. Contract creation might take upto 15 mins.</p> }
      </div>
      }

      { contract && contract.deployed &&
        <div className="contract-details">
          <p style={{ marginBottom: 20, color: '#4caf50' }}>Congratulations! Your new contract has been successfully deployed. And the tokens has been transferred to your account!</p>
          <p>Deployed: <strong>{ contract.deployed ? 'Yes' : 'No' }</strong></p>
          <p>Status: <strong>{ contract.status ? 'Successful' : 'Failed' }</strong></p>
          <p>Address: <strong>{ contract.address.substring(0, 20) }</strong></p>
          <p>Transaction Hash: <strong>{ contract.transactionHash.substring(0, 20) }</strong></p>

          <a href={`${contractBaseUrl}tx/${contract.transactionHash}`} target="_blank"><Button type="primary" ghost block>View Transaction</Button></a>
          <a href={`${contractBaseUrl}address/${contract.address}`} target="_blank"><Button type="primary" ghost block>View Contract</Button></a>
          <a href={`${contractBaseUrl}token/${contract.address}`} target="_blank"><Button type="primary" ghost block>View Token</Button></a>
          <Button type="primary" ghost block onClick={ addContractToMetaMask }>Add Contract To MetaMask</Button>

        </div>
      }


    </DetailsContainer>
  )


}

export default Deploy;




const DetailsContainer = styled.div`
  margin-top: 20px;
  border: 1px solid #434b5a;
  padding: 30px;
  border-radius: 5px;

  p {
    font-size: 16px;
    line-height: 20px;
    font-family: 'Balsamiq Sans', cursive;
    color: #2196f3;
  }

  .contract-details p {
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
  }
  .contract-details button { margin-top: 10px; }

  strong { text-decoration: underline; color: #FFF; }

`;


const FeesContainer = styled.div`
  p {
    font-size: 14px;
    line-height: 16px;
    font-family: 'Balsamiq Sans', cursive;
    margin-top: 10px;
  }


`;


